"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var styles = function styles(theme) {
  return {
    root: {
      color: theme.palette.primary.contrastText,
      lineHeight: "1.75",
      backgroundColor: theme.palette.primary.main,
      borderRadius: "2px",
      margin: "2px",
      padding: "0"
    },
    label: {
      color: theme.palette.primary.contrastText,
      padding: "3px 6px",
      borderRadius: "2px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    },
    deleteIcon: {
      cursor: "pointer",
      fill: theme.palette.primary.contrastText,
      height: "100%",
      width: "14px",
      padding: "0 4px",
      boxSizing: "content-box",
      margin: 0,
      marginLeft: "-4px",
      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, .15)"
      }
    },
    deletable: {
      "&:focus": {
        backgroundColor: theme.palette.primary.dark
      }
    },
    draggable: {
      display: "inline-block"
    }
  };
};

exports.styles = styles;